__turbopack_context__.v({
  "tooltipLight": "index-module___0ZExW__tooltipLight",
  "tooltipRoot": "index-module___0ZExW__tooltipRoot",
  "tooltipVip": "index-module___0ZExW__tooltipVip",
});
